import { Grid, styled } from "@mui/material";

export const GridButton = styled(Grid)(({theme}) => ({
    [theme.breakpoints.down("md")]: {
        marginTop: "1rem",
    }
}));